import { Helmet } from "react-helmet-async";
import { mediaUrl } from "../lib/api";

export const Seo = ({ title, description, image, type = "website", noindex = false }) => {
  const url = `${window.location.origin}${window.location.pathname}`;
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <link rel="canonical" href={url} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={mediaUrl(image)} />}
    </Helmet>
  );
};
